import { useAuthContext } from '../contexts/AuthContext';

/**
 * V4-HOOK-AGENCY-OWNER — Petit hook utilitaire qui retourne `true` si
 * l'utilisateur courant est propriétaire d'une agence (`agency.role === 'agency_owner'`).
 *
 * Centralise la vérification jusque-là dupliquée dans Sidebar et MobileBurgerMenu.
 * Suit le pattern des autres hooks « readers » (cf. useReadOnly).
 */
export function useIsAgencyOwner(): boolean {
  const { agency } = useAuthContext();
  return agency?.role === 'agency_owner';
}
